import { useState } from "react"
import { IconTrashOutline18 as Trash } from "nucleo-ui-outline-18"

import { AlertDialog, IconButton } from "@productlane/ui"
import {
	DropdownMenu,
	DropdownMenuGroup,
	DropdownMenuItem,
} from "@productlane/ui/src/components/internal/dropdown"
import { EllipsisIcon as MoreHorizontal } from "@productlane/ui/src/icons/project/ellipsis-icon"
import { mutators } from "@productlane/zero/mutators"

import { RoleCheck } from "@/components/shared/role-check"
import { toast } from "@/components/toast"
import { mutateOk, useZero } from "@/lib/zero"

export const LIVE_CHAT_DELETE_COPY = {
	menuItem: "Delete message",
	title: "Delete this message?",
	description: "It's removed from the customer's chat and from this thread.",
	confirm: "Delete",
	deleted: "Message deleted",
	failed: "Couldn't delete the message",
}

/** The ⋯ menu on a sent live chat message, for taking it back from the customer's chat. */
export function LiveChatMessageActions({ messageId }: { messageId: string }) {
	const zero = useZero()
	const [isConfirmOpen, setIsConfirmOpen] = useState(false)

	const deleteMessage = async () => {
		setIsConfirmOpen(false)
		try {
			await mutateOk(
				zero.mutate(mutators.liveChatMessages.delete({ id: messageId })),
			)
			toast.success({ title: LIVE_CHAT_DELETE_COPY.deleted })
		} catch (error) {
			toast.error({
				title: LIVE_CHAT_DELETE_COPY.failed,
				description: error instanceof Error ? error.message : undefined,
			})
		}
	}

	return (
		<RoleCheck not={["VIEWER"]}>
			<AlertDialog
				isOpen={isConfirmOpen}
				onOpenChange={setIsConfirmOpen}
				confirmText={LIVE_CHAT_DELETE_COPY.confirm}
				variant="positive"
				title={LIVE_CHAT_DELETE_COPY.title}
				description={LIVE_CHAT_DELETE_COPY.description}
				onCancel={() => setIsConfirmOpen(false)}
				onConfirm={() => void deleteMessage()}
			/>
			<div className="flex items-center opacity-0 focus-within:opacity-100 group-hover/live-chat-message:opacity-100 has-[[data-state=open]]:opacity-100">
				<DropdownMenu
					trigger={
						<IconButton
							Icon={MoreHorizontal}
							variant="ghost"
							size="sm"
							iconClassName="fill-current"
							aria-label="Message actions"
						/>
					}
					contentProps={{ side: "bottom", align: "end" }}
				>
					<DropdownMenuGroup>
						<DropdownMenuItem
							Icon={Trash}
							onClick={() => setIsConfirmOpen(true)}
						>
							{LIVE_CHAT_DELETE_COPY.menuItem}
						</DropdownMenuItem>
					</DropdownMenuGroup>
				</DropdownMenu>
			</div>
		</RoleCheck>
	)
}
